module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "assembleSubtest"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "id": "tryout-subtest-search-topic",
      "items": _vm.topics,
      "item-text": "nama",
      "dense": "",
      "disabled": !_vm.pdisabled,
      "return-object": "",
      "placeholder": "Cari berdasarkan bab/subbab",
      "outlined": ""
    },
    on: {
      "change": function($event) {
        _vm.$route.name == 'ModulPembelajaranForm' ?
          _vm.assignItem($event) :
          _vm.assignTopic($event)
      },
      "click": function($event) {
        _vm.showModal = false;
        _vm.loadTopics();
      }
    },
    scopedSlots: _vm._u([{
      key: "prepend-inner",
      fn: function() {
        return [_c('v-icon', {
          staticClass: "mr-2 my-0 pt-2",
          attrs: {
            "justify": ""
          }
        }, [_vm._v("mdi-magnify")])]
      },
      proxy: true
    }, {
      key: "append-outer",
      fn: function() {
        return [_c('v-btn', {
          staticClass: "blew--text",
          attrs: {
            "id": "tryout-subtest-anchor-topic-btn",
            "height": "40px",
            "elevation": "0",
            "color": "touchBlue",
            "disabled": !_vm.pdisabled
          },
          on: {
            "click": function($event) {
              _vm.showModal = true;
              _vm.loadTopics();
            }
          }
        }, [_vm._v("\n                Cari Berdasarkan Soal\n            ")])]
      },
      proxy: true
    }]),
    model: {
      value: (_vm.query),
      callback: function($$v) {
        _vm.query = $$v
      },
      expression: "query"
    }
  }), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "transition": "dialog-top-transition",
      "width": "940px",
      "min-height": "537px",
      "max-height": "771px",
      "scrollable": ""
    },
    on: {
      "click:outside": function($event) {
        _vm.showModal = false
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(dialog) {
        return [_c('v-card', [_c('v-card-title', {
          staticClass: "d-flex",
          attrs: {
            "width": "100%"
          }
        }, [_c('v-row', {
          staticClass: "py-3 align-center"
        }, [_c('v-col', {
          attrs: {
            "cols": "5"
          }
        }, [_c('v-autocomplete', {
          attrs: {
            "id": "tryout-subtest-bab-topic",
            "hide-details": "",
            "items": _vm.topics,
            "item-text": "nama",
            "outlined": "",
            "dense": "",
            "return-object": "",
            "placeholder": "Pilih Bab"
          },
          model: {
            value: (_vm.chapterIndex),
            callback: function($$v) {
              _vm.chapterIndex = $$v
            },
            expression: "chapterIndex"
          }
        })], 1), _vm._v(" "), _c('v-col', {
          attrs: {
            "cols": "5"
          }
        }, [_c('v-autocomplete', {
          attrs: {
            "id": "tryout-subtest-subbab-topic",
            "hide-details": "",
            "disabled": _vm.chapterIndex.subs.length < 1,
            "items": _vm.chapterIndex.subs,
            "item-text": "nama",
            "return-object": "",
            "outlined": "",
            "dense": "",
            "placeholder": "Pilih Subbab (optional)"
          },
          model: {
            value: (_vm.subChapterIndex),
            callback: function($$v) {
              _vm.subChapterIndex = $$v
            },
            expression: "subChapterIndex"
          }
        })], 1), _vm._v(" "), _c('v-col', {
          attrs: {
            "cols": "2"
          }
        }, [_c('v-btn', {
          staticClass: "pa-0",
          attrs: {
            "id": "tryout-subtest-search-topic-btn",
            "height": "39px",
            "block": "",
            "dark": "",
            "color": "blew",
            "elevation": "0"
          },
          on: {
            "click": function($event) {
              return _vm.search()
            }
          }
        }, [_vm._v("\n                                Cari\n                            ")])], 1)], 1)], 1), _vm._v(" "), (_vm.$route.name == 'ModulPembelajaranForm') ? _c('v-card-text', {
          staticClass: "px-0",
          attrs: {
            "width": "100%"
          }
        }, [_c('app-datatable', {
          attrs: {
            "id": "tryout-subtest-datatable-topic",
            "items": _vm.suggestions,
            "headers": _vm.headers,
            "has-custom-pagination": true,
            "hasMultiSearch": true,
            "has-custom-search": true,
            "custom-pagination-total-pages": _vm.maxPage,
            "custom-pagination-current-page": _vm.params.page,
            "custom-pagination-per-page": 10
          },
          on: {
            "dblClicked": function($event) {
              return _vm.assignItem($event)
            },
            "changePage": function($event) {
              return _vm.goToPage($event)
            },
            "doSearch": function($event) {
              _vm.filters = $event;
              _vm.doFilter();
            },
            "deleteOnFilter": function($event) {
              return _vm.delByOneFilter($event)
            }
          }
        })], 1) : _c('v-card-text', {
          staticClass: "px-0",
          attrs: {
            "width": "100%"
          }
        }, [_c('app-datatable', {
          attrs: {
            "id": "tryout-subtest-datatable-topic",
            "items": _vm.suggestions,
            "headers": _vm.headers,
            "has-custom-pagination": true,
            "hasMultiSearch": true,
            "has-custom-search": true,
            "custom-pagination-total-pages": _vm.maxPage,
            "custom-pagination-current-page": _vm.params.page,
            "custom-pagination-per-page": 10
          },
          on: {
            "dblClicked": function($event) {
              return _vm.assignAnchor($event)
            },
            "changePage": function($event) {
              return _vm.goToPage($event)
            },
            "doSearch": function($event) {
              _vm.filters = $event;
              _vm.doFilter();
            },
            "deleteOnFilter": function($event) {
              return _vm.delByOneFilter($event)
            }
          }
        })], 1), _vm._v(" "), _c('v-card-actions', {
          staticClass: "justify-end"
        }, [_c('v-btn', {
          attrs: {
            "id": "tryout-subtest-anchor-close-btn",
            "text": ""
          },
          on: {
            "click": function($event) {
              dialog.value = false
            }
          }
        }, [_vm._v("\n                        Tutup\n                    ")])], 1)], 1)]
      }
    }]),
    model: {
      value: (_vm.showModal),
      callback: function($$v) {
        _vm.showModal = $$v
      },
      expression: "showModal"
    }
  }), _vm._v(" "), _vm._l((_vm.details), function(subtestDetail, index) {
    return _c('v-card', {
      key: index,
      staticClass: "mb-2",
      attrs: {
        "flat": "",
        "min-width": "713px",
        "outlined": "",
        "id": 'tryout-subtest-topic-' + index
      }
    }, [_c('v-list', [
      [_c('v-list-item', {
        staticClass: "font-weight-bold",
        attrs: {
          "two-line": ""
        }
      }, [_c('v-list-item-content', {
        staticClass: "mx-2 my-0",
        staticStyle: {
          "max-width": "45px"
        }
      }, [_c('v-list-item-subtitle', [_c('span', {
        staticClass: "lightgreynew--text font-weight-500 font-size-12"
      }, [_vm._v("No")])]), _vm._v(" "), _c('v-list-item-subtitle', [_vm._v(_vm._s(index + 1))])], 1), _vm._v(" "), (subtestDetail.is_anchor) ? _c('v-list-item-content', [_c('v-list-item-subtitle', [_c('span', {
        staticClass: "lightgreynew--text font-weight-500 font-size-12"
      }, [_vm._v("\n                                Kode Soal\n                            ")])]), _vm._v(" "), _c('v-list-item-subtitle', [_vm._v("\n                            " + _vm._s(subtestDetail.item_code) + "\n                        ")])], 1) : _c('v-list-item-content', [_c('v-list-item-subtitle', [_c('span', {
        staticClass: "lightgreynew--text font-weight-500 font-size-12"
      }, [_vm._v("\n                                Topik\n                            ")])]), _vm._v(" "), _c('v-list-item-subtitle', [_vm._v("\n                            " + _vm._s(_vm.getTopicText(subtestDetail)) + "\n                        ")])], 1), _vm._v(" "), (_vm.$route.name == 'ModulPembelajaranForm') ? _c('v-list-item-content', [_c('v-list-item-subtitle', [_c('span', {
        staticClass: "lightgreynew--text font-weight-500 font-size-12"
      }, [_vm._v("\n                                Video Pembahasan\n                            ")])]), _vm._v(" "), _c('v-list-item-subtitle', [_c('a', {
        attrs: {
          "target": "newtab",
          "href": subtestDetail.video_pembahasan
        }
      }, [_vm._v(_vm._s(subtestDetail.video_pembahasan))])])], 1) : _vm._e(), _vm._v(" "), (_vm.$route.name == 'ModulPembelajaranForm') ? _c('v-list-item-action', {
        staticClass: "px-2"
      }, [_c('v-btn', {
        staticClass: "pa-0",
        attrs: {
          "id": "tryout-subtest-add-video-btn",
          "width": "32px",
          "height": "32px",
          "elevation": "0"
        },
        on: {
          "click": function($event) {
            return _vm.editVideo(subtestDetail)
          }
        }
      }, [_c('v-icon', [_vm._v("mdi-pencil")])], 1)], 1) : _vm._e(), _vm._v(" "), (
        _vm.$store.state.tryout.status != 'PUBLISHED' &&
        index != 0
      ) ? _c('v-list-item-action', {
        staticClass: "px-2"
      }, [_c('v-btn', {
        staticClass: "pa-0",
        attrs: {
          "id": "tryout-subtest-increase-sequence-btn",
          "width": "32px",
          "height": "32px",
          "elevation": "0"
        },
        on: {
          "click": function($event) {
            return _vm.moveUp(subtestDetail)
          }
        }
      }, [_c('v-icon', [_vm._v("mdi-menu-up")])], 1)], 1) : _vm._e(), _vm._v(" "), (
        _vm.$store.state.tryout.status != 'PUBLISHED' &&
        index != _vm.details.length - 1
      ) ? _c('v-list-item-action', {
        staticClass: "px-2"
      }, [_c('v-btn', {
        staticClass: "pa-0",
        attrs: {
          "id": "tryout-subtest-decrease-sequence-btn",
          "width": "32px",
          "height": "32px",
          "elevation": "0"
        },
        on: {
          "click": function($event) {
            return _vm.moveDown(subtestDetail)
          }
        }
      }, [_c('v-icon', [_vm._v("mdi-menu-down")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$store.state.tryout.status != 'PUBLISHED') ? _c('v-list-item-action', {
        staticClass: "pr-2"
      }, [_c('v-btn', {
        staticClass: "pa-0 red--text",
        attrs: {
          "id": "tryout-subtest-confirm-close-btn",
          "width": "32px",
          "height": "32px",
          "dark": "",
          "elevation": "0",
          "color": "lightred"
        },
        on: {
          "click": function($event) {
            _vm.dialogConfirm.function = subtestDetail;
            _vm.dialogConfirm.title =
              'Apakah anda yakin akan menghapus soal ini?';
            _vm.dialogConfirm.open = true;
          }
        }
      }, [_c('v-icon', [_vm._v("mdi-delete-outline")])], 1)], 1) : _vm._e()], 1)]
    ], 2)], 1)
  }), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "506px"
    },
    model: {
      value: (_vm.dialogPembahasan),
      callback: function($$v) {
        _vm.dialogPembahasan = $$v
      },
      expression: "dialogPembahasan"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticStyle: {
      "word-break": "break-word !important"
    }
  }, [_vm._v("\n                URL Video Pembahasan\n            ")]), _vm._v(" "), _c('v-card-subtitle', [_vm._v("\n                Setiap soal wajib mempunyai Video Pembahasan\n            ")]), _vm._v(" "), _c('v-card-text', [_c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-text-field', {
    attrs: {
      "placeholder": "https://",
      "outlined": ""
    },
    model: {
      value: (_vm.videoUrl),
      callback: function($$v) {
        _vm.videoUrl = $$v
      },
      expression: "videoUrl"
    }
  })], 1)], 1), _vm._v(" "), (_vm.showVideo) ? _c('div', [_c('youtube', {
    key: _vm.showVideo,
    ref: "youtube",
    staticClass: "mt-2",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": "tryout-subtest-youtube-url",
      "video-id": _vm.$youtube.getIdFromUrl(_vm.videoUrl)
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-btn', {
    staticClass: "font-weight-bold dark--text",
    staticStyle: {
      "box-shadow": "0px 4px 4px rgba(0, 0, 0, 0.05)",
      "border-radius": "4px"
    },
    attrs: {
      "block": "",
      "depressed": "",
      "color": "#FAFAFA"
    },
    on: {
      "click": function($event) {
        _vm.showVideo = true
      }
    }
  }, [_vm._v("Preview Video")])], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "blew",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.addVideo(_vm.selectedItem, _vm.videoUrl, _vm.isEdit)
      }
    }
  }, [_vm._v("\n                    Selesai\n                ")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "450"
    },
    model: {
      value: (_vm.dialogConfirm.open),
      callback: function($$v) {
        _vm.$set(_vm.dialogConfirm, "open", $$v)
      },
      expression: "dialogConfirm.open"
    }
  }, [_c('dialog-confirm', {
    attrs: {
      "title": _vm.dialogConfirm.title,
      "subtitle": _vm.dialogConfirm.subtitle
    },
    on: {
      "close": function($event) {
        _vm.dialogConfirm.open = false
      },
      "confirm": function($event) {
        _vm.remove(_vm.dialogConfirm.function);
        _vm.dialogConfirm.open = false;
      }
    }
  })], 1), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d78b8abe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/tryout/components/AssembleSubTest.vue
// module id = 1504
// module chunks = 1